import { render, staticRenderFns } from "./IllustrationIntroSection.vue?vue&type=template&id=223676d0"
import script from "./IllustrationIntroSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationIntroSection.vue?vue&type=style&index=0&id=223676d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports